/**
 * Resolves with `promise`'s value, or with `null` once `ms` passes first. Requests have no timeout
 * of their own (apiFetch), so callers that wait on one use this to never spin forever. The request is
 * left running; a late answer still updates whatever store it writes to.
 */
export async function withTimeout<T>(promise: Promise<T>, ms: number): Promise<T | null> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const timedOut = new Promise<null>((resolve) => {
    timer = setTimeout(() => resolve(null), ms);
  });
  try {
    return await Promise.race([promise, timedOut]);
  } finally {
    clearTimeout(timer);
  }
}
